import "../stylesheets/hero.scss";
import Schedule from "./Schedule";

// PROPS

type HeroProps = {
	image: string;
	title?: string;
	subtitle?: string;
	showSchedule?: boolean;
};

// CONST

// COMPONENT

function Hero({ image, title, subtitle, showSchedule = false }: HeroProps) {
	const backgroundStyling = `linear-gradient(to top, #20161A 0%, transparent 30%), url(${image})`;
	return (
		<div
			className="hero"
			style={{ backgroundImage: `${backgroundStyling}` }}
		>
			<div>
				<div className="text-content">
					<h1>{title}</h1>
					<h2>{subtitle}</h2>
				</div>
				{showSchedule && <Schedule />}
			</div>
		</div>
	);
}

export default Hero;
